import React, { useEffect, useState} from 'react'
import {Dialogos} from './Dialogos'
import {Loader} from './Loader'
import {Card, Radio, Typography, Button, CardContent, Box} from '@mui/material' // Importamos Box
import Axios from 'axios'
import Alert from '@mui/material/Alert';
import Logo from '../componentes/Logo';
import { v4 as uuidv4 } from 'uuid';
import IconButton from '@mui/material/IconButton';
import { TextField } from '@mui/material';
const regex_solo_numeros = /^[0-9\b]+$/;

export const Ingreso = ({codigo,usuario,id_evento})=>{

    const [codigoweb,setCodigoWeb] = useState(null)
    const [dni,setDni] = useState(null)
    const [inscripto,setInscripto] = useState(null)
    const [loader,setLoader] = useState(false)
    const [verDetalle,setVerDetalle] = useState(false)
    const [inscriptos,setInscriptos] = useState(false)
    const [cargando,setCargando] = useState(false)
    const [texto,setTexto] = useState('')
    const [tipo,setTipo] = useState('dni')
    const [mail,setMail]=useState({asunto:'',mensaje:'',adjunto:null})



    useEffect(()=>{
        cargarInscriptos()
    },[])



    const cargarInscriptos = async ()=>{
        setCargando(true)
        try{
            const {data} = await Axios.get(process.env.NODE_ENV =='development' ? `http://localhost:3020/api/tablasgenerales/eventos/inscriptos/resumen/${id_evento}`:`https://uadapi.uad.digital/api/tablasgenerales/eventos/inscriptos/resumen/${id_evento}`)
            setInscriptos(data)
            setCargando(false)
        }catch(err){
            alert(err.response.data.message)
            setCargando(false)
        }
    }

    useEffect(()=>{
        setInscripto(null)
    },[codigoweb,dni])

    const validarCodigoWeb = async ()=>{
        try{
            setLoader(true)
            const {data} = await Axios.get(process.env.NODE_ENV =='development' ? `http://localhost:3020/api/eventos/colaborador/consulta/${codigo}/${usuario.nombre_usuario}/${id_evento}/${codigoweb}/cw`:`https://uadapi.uad.digital/api/eventos/colaborador/consulta/${codigo}/${usuario.nombre_usuario}/${id_evento}/${codigoweb}/cw`)
            setInscripto(data)
            setLoader(false)
            return data
        }catch(err){
            alert(err?.response?.data?.message || 'Error de validación 3')
            setLoader(false)
        }

    }



    const validarDni = async ()=>{
        try{
            setLoader(true)
            const {data} = await Axios.get(process.env.NODE_ENV =='development' ? `http://localhost:3020/api/eventos/colaborador/consulta/${codigo}/${usuario.nombre_usuario}/${id_evento}/${dni}/dni`:`https://uadapi.uad.digital/api/eventos/colaborador/consulta/${codigo}/${usuario.nombre_usuario}/${id_evento}/${dni}/dni`)
            setInscripto(data)
            setLoader(false)
            return data
        }catch(err){
            alert(err?.response?.data?.message || 'Error de validación 4')
            setLoader(false)
        }
    }



    const ingresarInscripto = async (item)=>{

        try{

            setLoader(true)

            const objetoaEnviar = {id_usuario:usuario.id_usuario,
                                        mp_id: item.mp_id ? item.mp_id : null,
                                        nro_cupon: item.nro_cupon ? item.nro_cupon : null,
                                        inscriptos:[item.id_evento_inscr]
                                    }

            const {data} = await Axios.post(process.env.NODE_ENV =='development' ? `http://localhost:4002/api/tablasgenerales/evento/ingreso/inscripto/${id_evento}`:`https://administracion.uad.digital/api/tablasgenerales/evento/ingreso/inscripto/${id_evento}`,objetoaEnviar)

            setInscripto(data)



            if(dni){
                const data = await validarDni()
                if (!data.some(i=>i.presente==0)){ // si todos los inscriptos con el mismo código web ya están presentes se cierra el dialogo
                     setTimeout(() => {
                         setDni('')
                    }, 3000);
                }
               
            }

            if(codigoweb){
                const data = await validarCodigoWeb()
                if (!data.some(i=>i.presente==0)){ // si todos los inscriptos con el mismo código web ya están presentes se cierra el dialogo
                    setTimeout(() => {
                        setCodigoWeb('')
                    }, 3000);
                }

            }
            cargarInscriptos()
            setLoader(false)
        }catch(err){
            alert(err?.response?.data?.message || 'Error de ingreso')
            setLoader(false)
        }

    }


    const handleChangeCodigoWeb = (e) => {
    const inputValue = e.target.value.trim();
    const parts = inputValue.split('-');
    const codigoPrincipal = parts[0];

    if (regex_solo_numeros.test(codigoPrincipal) || codigoPrincipal === '') {
        setCodigoWeb(codigoPrincipal);
        setDni('');
    } else {
        console.warn("Entrada no válida: solo se permiten números en la primera parte del código.");
    }

};



    const handleChangeDni = (e)=>{
        setCodigoWeb('')
        if(regex_solo_numeros.test(e.target.value.trim()) || e.target.value.trim()==''){
            setDni(e.target.value)
        }
    }
    return (

        <Box
            sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            p: 2,
            maxWidth: { xs: '100%', md: 500 },
            margin: '0 auto',
            minHeight:'350px', // Mantenemos la altura mínima
        }}
        >

            <Typography sx={{mt:0.5, mb:2}} variant="h6">Busque un inscripto:</Typography>
            <TextField
                autoFocus
                inputProps={{maxLength: 9}}  
                value={dni}
                placeholder="DNI"
                onChange={handleChangeDni}
                type="text"
                fullWidth
                sx={{ mb: 2 }} // Añade margen inferior
            />

            {dni && (
                <Box
                    sx={{
                        display:'flex',
                        justifyContent:'space-between',
                        mt:'1rem',
                        width: '100%'
                    }}

                >
                    <Button variant="contained" color="primary" onClick={validarDni}>
                        Validar DNI
                    </Button>
                    <IconButton sx={{ml:'1rem'}} onClick={()=>setDni('')}>
                    </IconButton>
                </Box>

            )}

            <Box sx={{ my: 3 }} /> {/* Sustituye <br /> */}
                <TextField
                    inputProps={{maxLength: 5}}  
                    value={codigoweb}
                    placeholder="Ingrese o escanee el código web"
                    onChange={handleChangeCodigoWeb}
                    type="text"
                    fullWidth
                    sx={{ mb: 2 }}
                />
                 <Typography variant="body2" color="text.secondary" sx={{ mb: 2, textAlign: 'left' }}>
                    *** (Puede escanear el QR de la constancia de inscripción)
                </Typography>
                {codigoweb && (
                    <Box sx={{
                        display:'flex',
                        justifyContent:'space-between',
                        mt:'1rem',
                        width: '100%'
                    }}>

                        <Button variant="contained" color="primary" onClick={validarCodigoWeb}>
                            Validar código web
                        </Button>

                        <IconButton sx={{ml:'1rem'}} onClick={()=>setCodigoWeb('')}>
                        </IconButton>
                </Box>
            )}

            {inscripto && inscripto?.length==0 &&
                <Alert sx={{fontSize:'large', mt: 3}} severity="warning" variant='outlined'>
                    No se encontraron datos
                </Alert>
            }

            <Dialogos open={inscripto && inscripto?.length>0}
                titulo="Validación de datos e ingreso"
                closeHeader
                procesarCancelar = {()=>{setDni('');setCodigoWeb('')}}
            >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                p: 2,
                                maxWidth: { xs: '100%', md: 500 },
                                margin: '0 auto',
                                minHeight:'350px',
                            }}
                        >
                                <Box sx={{ px: 2, pt: 1, pb: 2, backgroundColor: '#f9f9f9' }}>
                                    {inscripto && inscripto?.length > 0 && (
                                        <Typography variant="h5" color="primary" sx={{ mb: 2, fontWeight: 700, textAlign: 'center' }}>
                                            {inscripto[0]?.detalle}
                                        </Typography>
                                    )}
                                    {inscripto && inscripto?.length > 0 && ( <>
                                        <Typography variant="subtitle1" color="secondary" sx={{ textAlign: 'center' }}>
                                             Mercadopago: {inscripto[0]?.mp_id}
                                        </Typography>
                                         <Typography variant="subtitle1" color="secondary" sx={{ textAlign: 'center' }}>
                                            Código web: {inscripto[0]?.codigo_web}
                                        </Typography>
                                        </>
                                    )}

                                    {inscripto && inscripto?.length > 0 && inscripto.map((item, index) => (

                                        <Card
                                            key={index}
                                            variant="outlined" // Borde sutil
                                            sx={{
                                                mt: 1.5,
                                                p: 2,
                                                backgroundColor: item.presente ? '#e8f5e9' : 'white', // Verde claro si ya ingresó
                                                boxShadow: 2
                                            }}

                                        >
                                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                                <Typography variant="h5" sx={{ color: '#3f51b5' }}>
                                                    {item.nombre}
                                                </Typography>

                                                <Typography variant="h6" color="text.secondary">
                                                    DNI: {item.nro_documento} | Edad: {item.edad_actual} | Sexo: {item.sexo === 'M' ? 'HOMBRE' : 'MUJER'}
                                                </Typography>
                                                <Box sx={{ mt: 1, mb: 1 }}>

                                                    <Typography
                                                        variant="caption"
                                                        sx={{
                                                            backgroundColor: item.categoria === 'UAD' ? '#1976d2' : '#f57c00', // Azul o Naranja
                                                            color: 'white',
                                                            px: 1,
                                                            py: 0.5,
                                                            borderRadius: '4px',
                                                            fontWeight: 600
                                                        }}

                                                    >
                                                        {item.categoria=='UAD' ? 'UAD':'EXTERNO'}
                                                    </Typography>

                                                </Box>
                                                {item.presente ? (
                                                    <Alert
                                                        severity="success"
                                                        variant='filled'
                                                        sx={{ mt: 2, justifyContent: 'center' }}
                                                    >
                                                        INGRESADO el {item?.fecha_ingreso} a las {item?.hora_ingreso} por {item?.usuario_ingreso}
                                                    </Alert>
                                                ) : (

                                                    <Button
                                                        onClick={() => ingresarInscripto(item)}
                                                        color="secondary"
                                                        variant="contained"
                                                        fullWidth
                                                        sx={{ mt: 2, height: 48 }}
                                                    >
                                                        CONFIRMAR INGRESO
                                                    </Button>
                                                )}
                                            </Box>
                                        </Card>
                                    ))}
                                </Box>
                        </Box>
            </Dialogos>

            <Loader open={loader}
                children={<Logo width='300px'/>}
                texto='Cargando...'
            />

            {inscriptos.inscriptos && (
                <Inscriptos inscriptos={inscriptos}/>

            )}
        </Box>

    )



}

const Inscriptos = ({inscriptos})=>{
    return <Box sx={{ mt: 4, width: '100%' }}>

                    <Box sx={{border:'1px solid gray',p:'15px',textAlign:'center'}}>

                        <Typography sx={{mt:0.5, mb:0.5}} variant="h6">

                            Resumen de inscriptos

                        </Typography>

                        {/* Contenedor de estadísticas: Usando Flexbox de MUI/Tailwind para layout */}

                        <Box className='flex justify-center' sx={{mt: 1, flexWrap: 'wrap', gap: 2}}>

                            {/* Nota: Las clases a-psts-c5, text-small, fw-700 se dejan como Tailwind/CSS custom, pero se envuelven en Box */}

                            {[{label: 'Inscriptos', count: inscriptos.inscriptos.length, filter: null},

                             {label: 'Ingresados', count: inscriptos.inscriptos.filter(item=>item.presente==1).length, filter: null},

                             {label: 'UAD', count: inscriptos.inscriptos.filter(item=>item.categoria=='UAD').length, filter: null},

                             {label: 'Externos', count: inscriptos.inscriptos.filter(item=>item.categoria=='EXT').length, filter: null},

                             {label: 'Becados UAD', count: inscriptos.inscriptos.filter(item=>item.cod_interno=='becado' && item.categoria=='UAD').length, filter: null},

                             {label: 'Becados EXT', count: inscriptos.inscriptos.filter(item=>item.cod_interno=='becado' && item.categoria=='EXT').length, filter: null}].map((stat, index) => (

                                <Box key={index} title={stat.label} className="a-psts-c5 p-1" sx={{ minWidth: 80, border: '1px solid #ccc', borderRadius: 1 }}>

                                    <Typography variant="body2" sx={{ fontSize: 'small', textAlign: 'center' }}>

                                        {stat.label}

                                    </Typography>

                                    {/* Nota: Simplificando la lógica de Becados en un solo componente Box para consistencia */}

                                    <Typography variant="body1" className="fw-700">

                                        {stat.count}

                                    </Typography>

                                </Box>

                            ))}

                        </Box>

                    </Box>

                </Box>
}